export default __webpack_public_path__ + "static/media/simple2.7636d175.webp";